import {deleteEvent} from '../../api/events'

export default store => event => {
  const {token, events} = store.getState()

  store.setState({
    isHydratingEvents: true,
  })

  if (!token) return

  return deleteEvent({
    token,
    event,
  })
    .then(res => {
      if (!res.ok) {
        throw res
      } else {
        return res.json()
      }
    })
    .then(response => {
      const remainingEvents = events.filter(
        ({_id}) => !response.documentIds.includes(_id),
      )
      store.setState({
        events: remainingEvents,
        isHydratingEvents: false,
      })
    })
    .catch(error => {
      store.setState({
        isHydratingEvents: false,
      })
    })
}
